import React from "react";
import { SOCKET_OBJ_DATA, SOCKET_OBJ_TOAST } from "../helper/const";

export default function ResponseCm({ data, children }) {
  console.log(data);
  
  return (
    <div className="mt-5 m-auto !font-dana-bold w-max my-10  flex flex-col rounded-xl justify-center items-center bg-white p-32 font-kalameh !text-4xl max-[800px]:p-4 max-[800px]:w-full max-[600px]:text-xl absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
      <div
        style={{
          color: SOCKET_OBJ_TOAST[data.type || "error"].color,
        }}
        className="text-center flex flex-col text-3xl justify-center items-center"
      >
        {SOCKET_OBJ_DATA[data.code].icon}
        <div className="mt-4"></div>
        {data.message}
        {children}
      </div>
    </div>
  );
}
